//================================= ANIMAZIONI

/*let appearAnimation = appear({
	elements: function elements(){
		return $('.appear-animation, .fade-in-animation');
	},
	appear: function appear(el){
		$(el).addClass('appear-animated');
	},
	bounds: -50,
	reappear: false
});

let opacityAnimation = appear({
	elements: function elements(){
		return $('.opacity-animation');
	},
	appear: function appear(el){
		$(el).addClass('opacity-animated');
	},
	bounds: -50,
	reappear: false
});*/


// add progressively increasing delay for each child of items with "sequential-animation" class
let sequentialDelay = 0;

document.querySelectorAll('.sequential-animation .wow')
	.forEach((item) => {
			sequentialDelay = sequentialDelay + 100;
			item.setAttribute('data-wow-delay', sequentialDelay);
		}
	);

/**
 * Add animations to columns
 */
document.querySelectorAll('.wp-block-columns')
	.forEach((item) => {
			const columns = item.querySelectorAll('.wp-block-column');

			if (columns.length === 2)
			{
				columns.forEach((col, i) => {
						if (i === 0)
						{
							col.classList.add('wow', 'animate__fadeInLeft');
						}
						else
						{
							col.classList.add('wow', 'animate__fadeInRight');
						}
					}
				);
			}

			if (columns.length > 2)
			{
				columns.forEach((col, i) => {
						col.classList.add('wow', 'animate__fadeInUp', 'animate__delay-' + i + 's');
					}
				);
			}
		}
	);


/**
 * Add animations to headings
 */
document.querySelectorAll('.wp-block-heading')
	.forEach((item) => {
			const parentColumn = item.closest('.wp-block-column');

			// add classes if the heading is not contained in an already animated column
			if (parentColumn !== null && !parentColumn.classList.contains('wow'))
			{
				item.classList.add('wow', 'animate__fadeInUp');
			}
		}
	);

// initialize WOW
var wow = new WOW(
	{
		animateClass: 'animate__animated', // animation css class (default is animated)
	}
);
wow.init();

document.querySelectorAll('.PromoBanner[data-countdown]').forEach(function(banner) {
    var target = new Date(banner.dataset.countdown.replace(' ', 'T')).getTime();

    var countdown = banner.querySelector('.PromoBanner_Countdown');

    function update() {
        var diff = target - Date.now();

        if (diff <= 0) {
            countdown?.remove();
            return;
        }

        if (!countdown) return;

        var totalMinutes = Math.floor(diff / 60000);
        var days    = Math.floor(totalMinutes / 1440);
        var hours   = Math.floor((totalMinutes % 1440) / 60);
        var minutes = totalMinutes % 60;

        countdown.querySelector('[data-unit="days"]').textContent    = days;
        countdown.querySelector('[data-unit="hours"]').textContent   = hours;
        countdown.querySelector('[data-unit="minutes"]').textContent = minutes;
    }

    update();
    setInterval(update, 60000);
});